import { Stack, Typography } from '@mui/material';
import { formatCurrency } from 'utils';
import { Nullable } from 'global';
import { QuoteCalcViewModel } from 'modules/quote';
import { SummaryCard } from './SummaryCard';

interface Props {
  priceCalc: Nullable<QuoteCalcViewModel>;
}

export const InsightsCards = ({ priceCalc }: Props) => {
  const marginRate = priceCalc?.profitability?.marginRate ?? 0;

  return (
    <>
      <Typography variant="subtitle1" fontWeight={500} pt={1}>
        Deal Insights
      </Typography>
      <Stack direction="row" gap={1.5}>
        <SummaryCard
          label="Customer Savings"
          value={formatCurrency(priceCalc?.netFinanceAmount?.customerSavings?.amount, true)}
          caption={`(${(priceCalc?.netFinanceAmount?.customerSavings?.percent ?? 0).toFixed(1)}%)`}
          type="customerSavings"
        />
        <SummaryCard
          label="Gross Profit"
          value={formatCurrency(priceCalc?.profitability?.grossProfit, true)}
          type="grossProfit"
        />
        <SummaryCard label="Profit Margin" value={`${(marginRate * 100).toFixed(1)}%`} type="profitMargin" />
      </Stack>
    </>
  );
};
